import React from 'react';
import color from '@deprecated-ui/_style/color';
import styled from 'styled-components';

const BodyWrapper = styled.div`
  position: relative;
  display: block;
  max-width: 990px;
  background-color: ${color.light};
  border: 1px solid ${color.gainsboro};
  border-radius: 3px;
`;

const CalendarBody = ({ children }: { children: React.ReactNode }) => (
  <div style={{ paddingBottom: '30px' }} id="today_event">
    <BodyWrapper>{children}</BodyWrapper>
  </div>
);

export default CalendarBody;
